import { ListApiResponse } from '../types/apiResponse';
import {
  UserProfileGroupListItem,
  UserProfileGroupMemberListItem,
} from '../types/userProfileGroup';
import {
  apiUrl,
  getList,
  getAll,
  getSingleRecord,
  saveRecord,
  deleteRecord,
  postAction,
  deleteAction,
  exportData,
  get,
  postArray,
  deleteArray,
} from './apiUtils';
import type { ApiListParams } from '../types/api/listParams';
const baseUrl = apiUrl + '/userprofilegroups/';

export function getUserProfileGroups(
  params?: ApiListParams
): Promise<ListApiResponse<UserProfileGroupListItem>> {
  return getList<UserProfileGroupListItem>(`${baseUrl}search`, params);
}

export function getAllUserProfileGroups(): Promise<UserProfileGroupListItem[]> {
  return getAll(baseUrl);
}

export function getUserProfileGroupById(
  id: string
): Promise<UserProfileGroupListItem> {
  return getSingleRecord<UserProfileGroupListItem>(baseUrl, id);
}

export function saveUserProfileGroup(
  userProfileGroup: UserProfileGroupListItem
): Promise<unknown> {
  return saveRecord(baseUrl, userProfileGroup);
}

export function deleteUserProfileGroup(id: string): Promise<unknown> {
  return deleteRecord(baseUrl, id);
}

export function addUserToGroup(
  userProfileGroupId: string,
  userProfileId: string
): Promise<unknown> {
  return postAction(`${baseUrl}${userProfileGroupId}/member/${userProfileId}`);
}

export function editUserGroups(
  userProfileGroupIds: string,
  userProfileId: string
): Promise<unknown> {
  return postAction(`${baseUrl}member/${userProfileId}`, {
    userProfileGroupIds,
  });
}

export function removeUserFromGroup(
  userProfileGroupId: string,
  userProfileId: string
): Promise<unknown> {
  return deleteAction(
    `${baseUrl}${userProfileGroupId}/member/${userProfileId}`
  );
}

export function exportUserProfileGroupData(
  params: import('../types/api/listParams').ApiExportParams
): Promise<void> {
  return exportData(
    `${apiUrl}/export/userProfileGroups/search`,
    'name',
    params
  );
}

// companies
export function getCompanies(userProfileGroupId: string): Promise<unknown> {
  return get(`${baseUrl}${userProfileGroupId}/companies`);
}
export function addCompanies(
  companyIds: string[],
  userProfileGroupId: string
): Promise<unknown> {
  return postArray(`${baseUrl}${userProfileGroupId}/companies`, companyIds);
}
export function deleteCompanies(
  companyIds: string[],
  userProfileGroupId: string
): Promise<unknown> {
  return deleteArray(`${baseUrl}${userProfileGroupId}/companies`, companyIds);
}
export function getMembers(
  userProfileGroupId: string
): Promise<ListApiResponse<UserProfileGroupMemberListItem>> {
  return get(`${baseUrl}${userProfileGroupId}/members`);
}

export function copyMembers(
  sourceProfileGroupId: string,
  targetProfileGroupId: string
): Promise<unknown> {
  return postAction(
    `${baseUrl}${sourceProfileGroupId}/copy-members/${targetProfileGroupId}`
  );
}
